var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoClean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174.36 174.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #004bff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.15,71.17v30.75l8.58,4.93c.42,.24,.83,.36,1.19,.36,1.04,0,1.77-.95,1.77-2.54V62.88c0-2.14-1.33-4.65-2.97-5.59l-14.82-8.52c-.42-.24-.83-.36-1.19-.36-1.04,0-1.77,.95-1.77,2.54v9.5l4.9,2.82c2.46,1.41,4.31,4.81,4.31,7.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.51,65.59l-3.57-2.05-1.34-.77-1.34-.77-8.58-4.93c-.42-.24-.83-.36-1.19-.36-1.04,0-1.77,.95-1.77,2.54v18.13l4.62-.99c.5-.11,1-.16,1.48-.16,1.83,0,3.46,.76,4.45,2.09,.94,1.25,1.21,2.88,.75,4.47-.69,2.38-2.92,4.35-5.56,4.91l-5.76,1.23v2.18c0,2.14,1.33,4.65,2.97,5.59l14.82,8.52c.42,.24,.83,.36,1.19,.36,.95,0,1.63-.79,1.75-2.12,.01-.14,.02-.27,.02-.42v-31.86c0-2.14-1.33-4.65-2.97-5.59Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.83,78.89c-.29,0-.6,.03-.92,.1l-5.18,1.11-1.34,.29-1.34,.29-26.35,5.63v6.09l26.35-5.63,1.34-.29,1.34-.29,5.2-1.11c1.67-.36,3.13-1.61,3.55-3.04,.51-1.78-.74-3.14-2.64-3.14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.06,76.02l-14.82-8.52c-.42-.24-.83-.36-1.19-.36-1.04,0-1.77,.95-1.77,2.54v2.01l3.5,2.01c2.46,1.41,4.31,4.81,4.31,7.91v28.3l9.98,5.74c.42,.24,.83,.36,1.19,.36,1.04,0,1.77-.95,1.77-2.54v-31.86c0-2.14-1.33-4.65-2.97-5.59Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.45,76.02l-2.17-1.25-1.34-.77-1.34-.77-9.98-5.74c-.42-.24-.83-.36-1.19-.36-1.04,0-1.77,.95-1.77,2.54v41.8c0,2.14,1.33,4.65,2.97,5.59l14.82,8.52c.42,.24,.83,.36,1.19,.36,1.04,0,1.77-.95,1.77-2.54v-41.8c0-2.14-1.33-4.65-2.97-5.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoClean);
export default __webpack_public_path__ + "static/media/logo-clean.59b72c938ade18a99b58d11b720f422f.svg";
export { ForwardRef as ReactComponent };